import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "components/Layout";
import { TopHeading, OuterWrapper } from "assets/css/global";
import { getAccountDetailsApi } from "redux/actions/manageAccount";
import HeadingIcon from "assets/svg/ManageAccountImage";
import { Heading } from "styles/pages/manage-orders";
import { BodyContainer } from "styles/pages/global";
import ViewAndEditUserInfo from "./ViewAndEditSections";
import AlertModal from "components/AlertModal";
import { useText } from "locales/useGetText";
const ManageAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locale = useText("manageAccount");
  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const [draftedDataList, setDraftedDataList] = useState();
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");
  const [modalLink] = useState("");

  useEffect(() => {
    fetchAccountDetails();
  }, []);

  const fetchAccountDetails = async () => {
    let response = "";
    response = await dispatch(
      getAccountDetailsApi(
        loggedInUserInfo?.locationType,
        loggedInUserInfo?.customerId,
        loggedInUserInfo?.token
      )
    );
    if (response.success) {
      setDraftedDataList(response.data);
    } else {
      if (
        response?.data?.error?.message === "Invalid Token" ||
        response.message === "Request failed with status code 401"
      ) {
        navigate("/");
      } else {
        setAlertModalContent(
          response?.data?.error?.message ||
            response.message ||
            locale("genericError")
        );
        setAlertModal(!alertModal);
      }
    }
  };

  const formFields = () => {
    return (
      <Layout activeTab="ManageAccount">
        <OuterWrapper>
          <TopHeading>
            <HeadingIcon />
            <Heading>
              <div>
                <h4>{locale("manageAccount")}</h4>
              </div>
            </Heading>
          </TopHeading>

          {draftedDataList && (
            <ViewAndEditUserInfo
              draftData={draftedDataList}
            />
          )}
        </OuterWrapper>
        <div data-testid="AlertModal">
          <AlertModal
            isOpen={alertModal}
            toggle={() => setAlertModal(!alertModal)}
            title={locale("alert")}
            content={alertModalContent}
            link={modalLink}
            className="alert-msg-container"
            InnerClassName="alert-msg"
          />
        </div>
      </Layout>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default ManageAccount;
